/* eslint-disable */

// PASS 시작(실제에선 redirectUrl 반환)
export async function startPassVerification({ returnUrl }) {
    console.log("[stub] startPassVerification → returnUrl:", returnUrl);
    // 실제 연동 시: sessionId/redirectUrl 생성 후 리다이렉트
    return { ok: true, sessionId: crypto.randomUUID(), redirectUrl: null };
}

// 알림톡 OTP 발송(실제에선 발송 sid 반환)
export async function sendAlimtalkOtp({ phoneE164 }) {
    console.log("[stub] sendAlimtalkOtp →", phoneE164);
    return { ok: true, sid: crypto.randomUUID() };
}

// 알림톡 OTP 검증(실제에선 서버 검증)
// 지금은 더미로 6자리면 ok 처리
export async function verifyAlimtalkOtp({ sid, code }) {
    console.log("[stub] verifyAlimtalkOtp →", sid, code);
    const ok = typeof code === "string" && code.replace(/\D/g, "").length === 6;
    return { ok };
}
